import { render, staticRenderFns } from "./WorkQueueBanner.vue?vue&type=template&id=94659f9e&"
import script from "./WorkQueueBanner.vue?vue&type=script&lang=js&"
export * from "./WorkQueueBanner.vue?vue&type=script&lang=js&"
import style0 from "./WorkQueueBanner.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VSnackbar } from 'vuetify/lib/components/VSnackbar';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VAvatar,VBtn,VSnackbar,VSpacer})
